import { loadContext } from 'src/api/loaders';
import type { RoutesFunc } from 'src/routes/routes';

import { VideosContext } from './shared';
import { Videos } from './videos-chat-layout';
import { VideosEmbed } from './videos-embed';

export const routes: RoutesFunc = () => [
  {
    path: '/videos',
    id: 'video-reload',
    loader: () => {
      window.location.reload();
      return null;
    },
    Component: () => null,
  },
  {
    path: '/videos/:uuid',
    id: 'video',
    loader: () => loadContext<VideosContext>(),
    Component: Videos,
    HydrateFallback: () => null,
  },
  {
    path: '/videos-embed/:uuid',
    id: 'video-embed',
    loader: () => loadContext<VideosContext>(),
    Component: VideosEmbed,
    HydrateFallback: () => null,
  },
];
